import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const ServiceBoard: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 3 }}>
        Quadro de Atendimento
      </Typography>
      
      <Card>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Performance e Produtividade dos Artistas
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Esta página será implementada com o quadro de atendimento de designers,
            mostrando quantidade de artes feitas mensalmente com gráficos.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ServiceBoard;
